import { defineProductDimensions, esMrpwPricingVersionDimension, esMrpwSelectedDimension } from '@orus.eu/dimensions'

import { esMrpwProductVersionDimension } from './es-mrpw-product-version-vocabulary.ts'
import { esMrpwQuoteDimension } from './es-mrpw-quote-dimension.ts'

export type * from './common-types.ts'
export * from './es-mrpw-activity-dimensions.ts'
export * from './es-mrpw-dimensions.ts'
export * from './es-mrpw-policy-item-dimensions.ts'
export * from './es-mrpw-product-version-vocabulary.ts'
export * from './es-mrpw-quote-dimension.ts'
export * from './es-mrpw-subscription-ui.ts'
export * from './es-mrpw-wakam-allowed-city-codes-dimension.ts'
export * from './es-mrpw-ui-elements.ts'

export const esMrpwDimensionsModule = defineProductDimensions({
  product: 'es-mrpw',
  family: 'mrp',
  selectionDimension: esMrpwSelectedDimension,
  productVersionDimension: esMrpwProductVersionDimension,
  pricingVersionDimension: esMrpwPricingVersionDimension,
  quoteV3Dimension: esMrpwQuoteDimension,
})
